var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQ4Window(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.828,
    height: 50.534,
    viewBox: "0 0 41.828 50.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hhiug",
    transform: "translate(1.589 1.857)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M0,45V16.168L19.5,0l8.775,7.276V5.12h4.55v5.928L39,16.168V45Z",
    transform: "translate(-0.427 -0.491)",
    fill: "#01a3da"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2",
    "data-name": "Path 2",
    transform: "translate(2.71 3.79)",
    fill: "#01a3da",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32.56317901611328 37.62817764282227 L 0.749997615814209 37.62817764282227 L 0.749997615814209 13.71946430206299 L 16.65984344482422 0.9614310264587402 L 32.56317901611328 13.71937274932861 L 32.56317901611328 37.62817764282227 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 16.65974617004395 1.922863006591797 L 1.499998092651367 14.07939529418945 L 1.499998092651367 36.87817764282227 L 31.81317710876465 36.87817764282227 L 31.81317710876465 14.0792179107666 L 16.65974617004395 1.922863006591797 M 16.65993690490723 -3.814697265625e-06 L 33.31317901611328 13.35952758789062 L 33.31317901611328 38.37817764282227 L -3.814697265625e-06 38.37817764282227 L -3.814697265625e-06 13.35952758789062 L 16.65993690490723 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_18",
    "data-name": "Union 18",
    d: "M-6079.589-1583.958v-41h5.07v3.551l14.048-11,1.422-1.758.415.32.829-.65,2.517,3.109-.081.066,3.942,3.046v-.854h7v6.263l2.452,1.895v-3.99h4v7.08l.215.166-.215.105v31.648h-4v-29.691l-.456.223-8.2-6.7h-.791v-.645l-7.244-5.917-15.848,12.618v32.112Z",
    transform: "translate(6078 1632.635)",
    fill: "#fff",
    opacity: 0.644
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ4Window);
export default __webpack_public_path__ + "static/media/Q4_window.9bfd2c23bf27833a8e04d1c202b8e403.svg";
export { ForwardRef as ReactComponent };